<form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="form-layout">
    <div class="d-flex flex-row mb-3 justify-content-around">
        <div class="p-2 w-30" style="width:30%;">
            <input type="hidden" formControlName="id" style="width:100%;">
            <mat-form-field appearance="outline" style="width:100%;">
                <mat-label>Numer seryjny</mat-label>
                <input matInput type="text" required formControlName="serial_no">
            </mat-form-field>
            <mat-form-field appearance="outline" style="width:100%;">
                <mat-label>Adres IP</mat-label>
                <input matInput type="text" required formControlName="ipv4">
            </mat-form-field>
            <mat-form-field appearance="outline" style="width:100%;">
                <mat-label>Port</mat-label>
                <input matInput type="text" required formControlName="port">
            </mat-form-field>
            <mat-form-field appearance="outline" style="width:100%;">
                <mat-label>GPS Device ID</mat-label>
                <input matInput type="text" formControlName="gps_device_id">
            </mat-form-field>
        </div>
        <div class="p-2 w-30" style="width:30%;">
            <mat-form-field appearance="outline" style="width:100%;">
                <mat-label>Organizacja</mat-label>
                <mat-select formControlName="organization_id">
                    @for (item of organizations; track item) {
                    <mat-option [value]="item.id">{{item.name}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="p-2 w-30">
                
        </div>
    </div>
    <div class="d-flex align-content-end justify-content-end">
        <button mat-flat-button color="accent">{{ getSaveText() }}</button>
    </div>
</form>